/**
 * @author Wesley Mascarenhas
 * @version $Id: serviceMember.model.ts 79367 2018-02-17 00:41:28Z edivaldo.m.junior $
 */
export class ServiceMember {

  public id: string;
  public speedDial: string;
  public realNumber: string;
  public description: string;
  public editing: boolean;
  public edited: boolean;

  public  name:string;

  /** Member information (for instance, the reduced number/extension of a line) */
  public info:string;

  /** The member description */
  public  desc:string;

  /** The member date */
  public  date:any;

  public constructor() {

  }

}


// WEBPACK FOOTER //
// ./src/app/models/serviceMember.model.ts